// @flow
import * as React from 'react'

export const useIsOpeningEffect = (
  open: boolean,
  animationTimer: number = 300
) => {
  const [openingState, setOpening] = React.useState({
    prevOpen: open,
    isOpening: false,
  })

  React.useLayoutEffect(() => {
    if (open && !openingState.prevOpen) {
      setOpening({ prevOpen: true, isOpening: true })
      return
    }

    if (open !== openingState.prevOpen) {
      setOpening({ prevOpen: open, isOpening: openingState.isOpening })
    }
  }, [open, openingState])

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (openingState.isOpening) {
        setOpening({ ...openingState, isOpening: false })
      }
    }, animationTimer)

    return () => {
      window.clearTimeout(timer)
    }
  }, [openingState, animationTimer])

  return openingState.isOpening
}
